import React from "react";
import { Tooltip } from "antd";

const PASSWORD_NOTES = [
  "Password must be 8 to 15 characters long",
  "Include at least one uppercase (A–Z) and one lowercase (a–z) letter",
  "Include at least one number (0–9)",
  "Include at least one special character (!@#$%^&*)",
];

const PasswordNotesTooltip = () => (
  <Tooltip
    title={
      <div className="password-notes-tooltip">
        <div className="password-notes-tooltip__heading">Notes</div>
        <ol className="password-notes-tooltip__list">
          {PASSWORD_NOTES.map((note, index) => (
            <li key={index}>{note}</li>
          ))}
        </ol>
      </div>
    }
    placement="top"
    overlayClassName="password-notes-tooltip-overlay"
  >
    <i
      className="fas fa-info-circle password-notes-tooltip-icon"
      aria-hidden="true"
    />
  </Tooltip>
);

export default PasswordNotesTooltip;

